<div class="bg-surface-card border border-stroke-soft rounded-[8px] p-6 flex flex-col gap-6 h-full">
  <!-- Email Subject -->
  <juno-libs-ui-input
    [formField]="form().emailSubject"
    label="CONTRACT_ORDER.EMAIL_SUBJECT"
    placeholder="CONTRACT_ORDER.EMAIL_SUBJECT_PLACEHOLDER"
  />

  <!-- Email Body -->
  <juno-libs-ui-textarea
    [rows]="8"
    [resize]="'none'"
    [formField]="form().emailBody"
    label="CONTRACT_ORDER.EMAIL_BODY"
    placeholder="CONTRACT_ORDER.EMAIL_BODY_PLACEHOLDER"
  />
</div>
